// extracted by mini-css-extract-plugin
export var margin = "NonResidentsOffer--margin--3WLkg";
export var nonUkOffer = "NonResidentsOffer--nonUkOffer---RA14";
export var nonUkOffer__button = "NonResidentsOffer--nonUkOffer__button--fTkvg";
export var nonUkOffer__image = "NonResidentsOffer--nonUkOffer__image--vOEaq";
export var nonUkOffer__link = "NonResidentsOffer--nonUkOffer__link--thX7t";
export var nonUkOffer__panel = "NonResidentsOffer--nonUkOffer__panel--pH-nu";
export var nonUkOffer__text = "NonResidentsOffer--nonUkOffer__text--59etG";
export var nonUkOffer__title = "NonResidentsOffer--nonUkOffer__title--XcTAg";
export var tkMyriadProSemiCondensed = "NonResidentsOffer--tk-myriad-pro-semi-condensed--hTD9w";